import { PlusCircleIcon } from '@heroicons/react/outline';
import Popup from '../Low Level/Popup';
import { useEffect, useState } from 'react';
import NewTransferPopupBody from '../Low Level/NewTransferPopupBody';
import * as React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import CanvasJSReact from '@canvasjs/react-stockcharts';

const timeDomainOptions = [
  'All',
  'Year',
  'Month',
  'Week',
  'Day',
  'Hour',
  //'Past Charlington Day',
];

const StockMarket = ({
  user,
  citizenID,
  database,
  getTime,
  getDate,
  getYear,
}) => {
  const [newTransferPopupOpen, setNewTransferPopupOpen] = useState(false);
  const [westers, setWesters] = useState(user.westers);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);
  const [businessFilterInput, setBusinessFilterInput] = useState(
    localStorage.getItem('businessFilterInput'),
  );
  //localStorage.getItem('businessFilterInput')
  const [timeDomain, setTimeDomain] = useState('Week');
  const [totalInvested, setTotalInvested] = useState(0);
  const [initialStockPricesWhenLoaded, setInitialStockPricesWhenLoaded] =
    useState(new Map());

  //const [sharesEntering]

  useEffect(initializeBusinesses, []);

  useEffect(setRealtimeUpdate, []);

  console.log('calling whole thing');

  //useEffect(setBusinessFilterInput, []);

  function setRealtimeUpdate() {
    database.ref('/businesses').on('value', (businessesSnapshot) => {
      console.log(
        'calling realtime update',
        businesses,
        businessesSnapshot.val(),
      );

      // Only call if the "businesses" state not defined yet
      if (businessesSnapshot.val()) {
        console.log('updating?');
        // const updatedBusinesses = businessesSnapshot.val();
        // updatedBusinesses.forEach((bus) => {
        //   const newStockHistory = [];
        //   bus.stockHistory.forEach((stockTrans) => {
        //     if (stockTrans.amountPaid > 0) {
        //       newStockHistory.push(stockTrans);
        //     }
        //   });
        //   bus.stockHistory = newStockHistory;
        // });

        // database.ref('/businesses').set(updatedBusinesses);

        let businessesList = Object.values(businessesSnapshot.val());
        businessesList.forEach((bus) => {
          bus.userEnteringValidSharesForBuy = false;
          bus.userEnteringValidSharesForSell = false;
          bus.sharesEntered = undefined;
          //$('#sharesInput').val(0);
          bus.userSellHint = '';
          bus.userBuyHint = '';
          //bus.stockHistory.push()

          // if (bus.stockHistory != undefined) {
          //   const newStockHistory = [];
          //   bus.stockHistory.forEach((stockTrans) => {
          //     if (
          //       stockTrans.amountPaid == undefined ||
          //       (stockTrans.amountPaid != undefined &&
          //         stockTrans.amountPaid > 0)
          //     ) {
          //       newStockHistory.push(stockTrans);
          //     }
          //   });
          //   bus.stockHistory = newStockHistory;
          //   database.ref(`/businesses/${bus.businessID}`).set(bus);
          // }
        });

        // let storageBusinessFilterInput = localStorage.getItem(
        //   'businessFilterInput'
        // );
        //setBusinessFilterInput(storageBusinessFilterInput);
        // if (storageBusinessFilterInput == null) storageBusinessFilterInput = '';

        setBusinesses(businessesList);
        // setFilteredBusinesses(
        //   businessesList.filter((business) => {
        //     return business.name
        //       .toUpperCase()
        //       .includes(businessFilterInput.toUpperCase());
        //   })
        // );
      }
    });

    database
      .ref(`/citizens/${user.citizenID}/westers`)
      .on('value', (westersSnapshot) => {
        setWesters(westersSnapshot.val());
      });
  }

  //updateBusinesses();

  function initializeBusinesses() {
    database
      .ref('/businesses')
      .get()
      .then((businessesSnapshot) => {
        if (businessesSnapshot.val()) {
          console.log('initializing?');
          // const updatedBusinesses = businessesSnapshot.val();
          // updatedBusinesses.forEach((bus) => {
          //   const newStockHistory = [];
          //   bus.stockHistory.forEach((stockTrans) => {
          //     if (stockTrans.amountPaid > 0) {
          //       newStockHistory.push(stockTrans);
          //     }
          //   });
          //   bus.stockHistory = newStockHistory;
          // });

          // database.ref('/businesses').set(updatedBusinesses);

          let businessesList = Object.values(businessesSnapshot.val());
          const updatedInitialPricesMap = new Map([
            ...initialStockPricesWhenLoaded,
          ]);
          businessesList.forEach((bus) => {
            bus.userEnteringValidSharesForBuy = false;
            bus.userEnteringValidSharesForSell = false;
            bus.sharesEntered = undefined;
            //$('#sharesInput').val(0);
            bus.userSellHint = '';
            bus.userBuyHint = '';

            updatedInitialPricesMap.set(
              bus.businessID,
              bus.stockHistory[bus.stockHistory.length - 1].price,
            );
            //bus.stockHistory.push()

            // if (bus.stockHistory != undefined) {
            //   const newStockHistory = [];
            //   bus.stockHistory.forEach((stockTrans) => {
            //     if (
            //       stockTrans.amountPaid == undefined ||
            //       (stockTrans.amountPaid != undefined &&
            //         stockTrans.amountPaid > 0)
            //     ) {
            //       newStockHistory.push(stockTrans);
            //     }
            //   });
            //   bus.stockHistory = newStockHistory;
            //   database.ref(`/businesses/${bus.businessID}`).set(bus);
            // }
          });

          setInitialStockPricesWhenLoaded(updatedInitialPricesMap);
          setBusinesses(businessesList);

          // let storageBusinessFilterInput = localStorage.getItem(
          //   'businessFilterInput'
          // );
          // if (storageBusinessFilterInput == null)
          //   storageBusinessFilterInput = '';

          //setFilteredBusinesses(businessesList);
        }
      });
  }

  function generateID(prefix) {
    var id = `${prefix}-`;
    for (var i = 0; i < 5; i++) {
      id = id + String(Math.floor(Math.random() * 10));
    }
    return id;
  }

  function censor(id) {
    return id.startsWith('CI-') && user.citizenID != id
      ? `CI-***${id.substring(6, 8)}`
      : id;
  }

  const stockUpColor = '#22c55e';
  const stockDownColor = '#dc2626';

  const charlingtonEpoch = 1766275200000;

  function onClickBuySell(buy, business, currentValue, testPerson) {
    let updatedBusinesses = [...businesses];

    const updatedBusiness = updatedBusinesses.find(
      (bus) => bus.businessID == business.businessID,
    );

    let totalSharesOwned = business.stockHistory.filter((stockTrans) => {
      return stockTrans.bought == true;
    }).length;

    let newValue = currentValue;
    let newBusinessBalance = business.westers;
    let oldBusinessBalance = business.westers;
    const now = Date.now();

    let amountPaid = 0;
    if (buy && business.userEnteringValidSharesForBuy) {
      console.log('made it here', totalSharesOwned);
      for (let i = 0; i < business.sharesEntered; i++) {
        //if (buy) {

        newValue = newValue + newValue * 0.05;

        totalSharesOwned++;

        newBusinessBalance = newValue * totalSharesOwned;

        // Make up the difference
        let newPrice = newBusinessBalance - oldBusinessBalance;

        amountPaid += newPrice;

        const newNewValueIfBought = newValue + newValue * 0.05;
        const newTotalSharesIfBought = totalSharesOwned + 1;
        const newNewBusinessBalanceIfBought =
          newNewValueIfBought * newTotalSharesIfBought;
        const newOldBusinessBalance = newBusinessBalance;
        const newNewPriceIfBought =
          newNewBusinessBalanceIfBought - newOldBusinessBalance;

        updatedBusiness.stockHistory = [
          ...updatedBusiness.stockHistory,
          {
            time: now,
            price: newNewPriceIfBought,
            amountPaid: newPrice,
            citizenID: testPerson ? 'CI-2392' : user.citizenID,
            citizenName: user.name,
            bought: true,
          },
        ];

        oldBusinessBalance = newBusinessBalance;

        //newBusinessBalance += newPrice;
        //newPrice = newBusinessBalance / totalSharesOwned;

        // newPrice += newPrice * 0.0005 * newBusinessBalance;
        // amountPaid += newPrice;
        // newBusinessBalance += newPrice;

        //else newPrice -= newPrice * 0.05;
      }

      const transferID = generateID('MT');

      if (updatedBusiness.transfers == undefined) {
        updatedBusiness.transfers = {};
      }

      updatedBusiness.transfers[transferID] = {
        transferID,
        amount: Number(amountPaid.toFixed(2)),
        date: getDate(),
        mssce: Date.now() - charlingtonEpoch,
        reason: `Bought ${business.sharesEntered} shares`,
        resultingBalance: Number(newBusinessBalance.toFixed(2)),
        senderID: user.citizenID,
        senderName: user.name,
        time: getTime(),
        type: 'Incoming',
      };

      updatedBusiness.westers = Number(newBusinessBalance.toFixed(2));

      database
        .ref(`/businesses/${updatedBusiness.businessID}`)
        .set(updatedBusiness);

      if (!testPerson) {
        database
          .ref(`/citizens/${user.citizenID}/westers`)
          .get()
          .then((westersSnapshot) => {
            let userResultingBalance = Number(
              (Number(westersSnapshot.val()) - amountPaid).toFixed(2),
            );
            database
              .ref(`/citizens/${user.citizenID}/westers`)
              .set(userResultingBalance);
            user.westers = userResultingBalance;
            const transferID = generateID('MT');
            database
              .ref(`/citizens/${user.citizenID}/transfers/${transferID}`)
              .set({
                transferID: transferID,
                date: `${getDate()}, ${getYear()}`,
                time: getTime(),
                mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                amount: Number(amountPaid.toFixed(2)),
                receiverID: 'BU-9999',
                receiverName: 'Stock Market',
                type: 'Outgoing',
                reason: `Bought ${business.sharesEntered} share(s) in ${business.name} ${business.businessID}`,
                resultingBalance: userResultingBalance,
                mssce: Math.round(new Date().getTime() - charlingtonEpoch),
              });
            //updateBusinesses();
          });
      }
      // } else {

      // }
    } else if (!buy && business.userEnteringValidSharesForSell) {
      for (let i = 0; i < business.sharesEntered; i++) {
        // const newPriceBumped = newPrice + newPrice * 0.1;
        // const newBusinessBalanceBumped = newBusinessBalance + newPriceBumped;

        // totalSharesOwned++;

        // newPrice = newBusinessBalanceBumped / totalSharesOwned;

        // amountPaid += newPrice;
        // newBusinessBalance += newPrice;

        const citizenID = testPerson ? 'CI-3423' : user.citizenID;

        //newBusinessBalance += newPrice;
        //newPrice = businessBalanceBumped / totalSharesOwned;

        //newPrice = newPrice / 1.05;
        // newBusinessBalance -= newPrice;
        // amountPaid += newPrice;

        // const newPriceDropped = newPrice / 1.1;
        // const newBusinessBalanceDropped = newBusinessBalance - newPriceDropped;
        // newPrice = newBusinessBalanceDropped / totalSharesOwned;

        // totalSharesOwned--;
        // newPrice =
        //   newBusinessBalance / (totalSharesOwned == 0 ? 1 : totalSharesOwned);

        newValue = newValue / 1.05;

        //if (newPrice <= 0) newPrice = 0;

        totalSharesOwned--;

        newBusinessBalance = newValue * totalSharesOwned;

        // Make up the difference
        const newPrice = oldBusinessBalance - newBusinessBalance;

        amountPaid += newPrice;
        oldBusinessBalance = newBusinessBalance;

        updatedBusiness.stockHistory = [
          ...updatedBusiness.stockHistory,
          {
            time: now,
            price: newPrice,
            citizenID: citizenID,
            citizenName: user.name,
            bought: false,
          },
        ];

        // totalSharesOwned--;
        // amountPaid += newPrice;
        // newBusinessBalance -= newPrice;

        // newPrice = newPrice / 1.1;

        let latestUserBuy = updatedBusiness.stockHistory.findLast((trans) => {
          return trans.citizenID == citizenID && trans.bought == true;
        });

        if (latestUserBuy) {
          let latestUserBuyIndex = updatedBusiness.stockHistory.findLastIndex(
            (trans) => {
              return trans.citizenID == citizenID && trans.bought == true;
            },
          );

          const updatedLatestUserBuy = {
            ...latestUserBuy,
          };

          updatedLatestUserBuy.bought = false;

          const updatedStockHistory = [...updatedBusiness.stockHistory];

          updatedStockHistory[latestUserBuyIndex] = updatedLatestUserBuy;

          updatedBusiness.stockHistory = updatedStockHistory;
        }
      }

      // updatedBusiness.stockHistory = [
      //   ...updatedBusiness.stockHistory,
      //   {
      //     time: now,
      //     price: newPrice,
      //     citizenID: user.citizenID,
      //     citizenName: user.name,
      //     bought: false,
      //   },
      // ];

      const transferID = generateID('MT');

      updatedBusiness.transfers[transferID] = {
        transferID,
        amount: Number(amountPaid.toFixed(2)),
        date: getDate(),
        mssce: Date.now() - charlingtonEpoch,
        reason: `Sold ${business.sharesEntered} shares`,
        resultingBalance: Number(newBusinessBalance.toFixed(2)),
        receiverID: user.citizenID,
        receiverName: user.name,
        time: getTime(),
        type: 'Outgoing',
      };

      updatedBusiness.westers = Number(newBusinessBalance.toFixed(2));

      database
        .ref(`/businesses/${updatedBusiness.businessID}`)
        .set(updatedBusiness);

      if (!testPerson) {
        database
          .ref(`/citizens/${user.citizenID}/westers`)
          .get()
          .then((westersSnapshot) => {
            let userResultingBalance = Number(
              (Number(westersSnapshot.val()) + amountPaid).toFixed(2),
            );
            database
              .ref(`/citizens/${user.citizenID}/westers`)
              .set(userResultingBalance);

            user.westers = userResultingBalance;
            const transferID = generateID('MT');
            database
              .ref(`/citizens/${user.citizenID}/transfers/${transferID}`)
              .set({
                transferID: transferID,
                date: `${getDate()}, ${getYear()}`,
                time: getTime(),
                mssce: Math.round(new Date().getTime() - charlingtonEpoch),
                amount: Number(amountPaid.toFixed(2)),
                senderID: 'BU-9999',
                senderName: 'Stock Market',
                type: 'Incoming',
                reason: `Sold ${business.sharesEntered} share(s) in ${business.name} ${business.businessID}`,
                resultingBalance: userResultingBalance,
                mssce: Math.round(new Date().getTime() - charlingtonEpoch),
              });
            //updateBusinesses();
          });
      }
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setBusinesses([...businesses]);
    }, 6000);
    return () => clearInterval(interval);
  });

  function updateSharesValid(e, business) {
    let updatedBusinesses = [...businesses];

    const updatedBusiness = updatedBusinesses.find(
      (bus) => bus.businessID == business.businessID,
    );

    updatedBusiness.sharesEntered = e.target.value;

    if (e.target.value != null && e.target.value > 0) {
      const sharesEntered = e.target.value;

      let amountPaidBuy = 0;
      let amountPaidSell = 0;

      const userBoughtTransactions = business.stockHistory.filter((trans) => {
        return trans.citizenID == user.citizenID && trans.bought == true;
      });

      let totalSharesOwned = business.stockHistory.filter((trans) => {
        return trans.bought == true;
      }).length;

      const newPrice = business.westers / totalSharesOwned;

      let newPriceBuy = newPrice;
      let newPriceSell = newPrice;
      let oldBusinessBalanceBuy = business.westers;
      let oldBusinessBalanceSell = business.westers;
      let newBusinessBalanceBuy = business.westers;
      let newBusinessBalanceSell = business.westers;
      let newTotalSharesOwnedBuy = totalSharesOwned;
      let newTotalSharesOwnedSell = totalSharesOwned;

      for (let i = 0; i < sharesEntered; i++) {
        newPriceBuy = newPriceBuy + newPriceBuy * 0.05;

        newTotalSharesOwnedBuy++;

        newBusinessBalanceBuy = newPriceBuy * newTotalSharesOwnedBuy;

        // Make up the difference
        amountPaidBuy += newBusinessBalanceBuy - oldBusinessBalanceBuy;
        oldBusinessBalanceBuy = newBusinessBalanceBuy;

        newPriceSell = newPriceSell / 1.05;

        //if (newPriceSell <= 0) newPriceSell = 0;

        newTotalSharesOwnedSell--;

        //newPriceSell =

        newBusinessBalanceSell = newPriceSell * newTotalSharesOwnedSell;

        // Make up the difference
        amountPaidSell += oldBusinessBalanceSell - newBusinessBalanceSell;
        oldBusinessBalanceSell = newBusinessBalanceSell;
      }

      console.log('amt', userBoughtTransactions.length, sharesEntered);
      //if (updatedBusiness.userEnteringValidSharesForBuy == false)
      if (
        userBoughtTransactions.length > 0 &&
        sharesEntered <= userBoughtTransactions.length
      ) {
        updatedBusiness.userEnteringValidSharesForSell = true;
        updatedBusiness.userSellHint =
          ' (W' +
          amountPaidSell.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          ')';
      } else {
        updatedBusiness.userEnteringValidSharesForSell = false;
        updatedBusiness.userSellHint =
          ' (W' +
          amountPaidSell.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          ')';
      }

      if (
        user.westers >= amountPaidBuy &&
        newPriceBuy > 0 &&
        sharesEntered <= 50
      ) {
        updatedBusiness.userEnteringValidSharesForBuy = true;
        updatedBusiness.userBuyHint =
          ' (W' +
          amountPaidBuy.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          ')';
      } else {
        updatedBusiness.userEnteringValidSharesForBuy = false;
        updatedBusiness.userBuyHint =
          ' (W' +
          amountPaidBuy.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          ')';
      }
    } else {
      updatedBusiness.userEnteringValidSharesForBuy = false;
      updatedBusiness.userBuyHint = '';
      updatedBusiness.userEnteringValidSharesForSell = false;
      updatedBusiness.userSellHint = '';
    }

    setBusinesses(updatedBusinesses);
  }

  function generateSummaryDataForDomain() {
    let differentialData = [];
    let data = [];

    businesses.forEach((bus) => {
      let numberOfUserShares = 0;
      let businessStockHistoryToPush = [];

      for (let i = 0; i < bus.stockHistory.length; i++) {
        const stockTrans = bus.stockHistory[i];
        const previousStockTrans = bus.stockHistory[i - 1];

        if (
          stockTrans.citizenID == user.citizenID &&
          stockTrans.bought == true
        ) {
          numberOfUserShares++;
        }

        if (previousStockTrans != undefined) {
          businessStockHistoryToPush.push({
            time: stockTrans.time,
            price: stockTrans.price - previousStockTrans.price,
          });
        } else {
          businessStockHistoryToPush.push({
            time: stockTrans.time,
            price: stockTrans.price,
          });
        }
      }

      if (numberOfUserShares > 0) {
        businessStockHistoryToPush.forEach((busStockTrans) => {
          differentialData.push({
            time: busStockTrans.time,
            price: busStockTrans.price,
          });
        });
      }
    });

    let runningPrice = 0;

    differentialData
      .sort((a, b) => a.time - b.time)
      .forEach((difData) => {
        runningPrice += difData.price;

        data.push({
          time: difData.time,
          price: runningPrice,
        });
      });

    data = [
      ...data,
      {
        time: Date.now(),
        price: runningPrice,
      },
    ];

    const foundTimes = new Set();

    // Filter duplicate times for better display
    data = data
      .reverse()
      .filter((stockTrans) => {
        if (!foundTimes.has(stockTrans.time)) {
          foundTimes.add(stockTrans.time);
          return true;
        } else return false;
      })
      .reverse();

    // 'Past Charlington 10 Years',
    //     'Past Charlington Year',
    //     'Past Charlington Month',
    //     'Past Charlington Day',
    if (timeDomain == 'Hour') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 3600000;
      });

      data = [
        {
          time:
            Date.now() - 3600000 < earliestTime
              ? earliestTime
              : Date.now() - 3600000,
          price: data[0].price,
        },
        ...data,
      ];
    } else if (timeDomain == 'Day') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 86400000;
      });

      data = [
        {
          time:
            Date.now() - 86400000 < earliestTime
              ? earliestTime
              : Date.now() - 86400000,
          price: data[0].price,
        },
        ...data,
      ];
    } else if (timeDomain == 'Week') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 604800000;
      });

      data = [
        {
          time:
            Date.now() - 604800000 < earliestTime
              ? earliestTime
              : Date.now() - 604800000,
          price: data[0].price,
        },
        ...data,
      ];
    } else if (timeDomain == 'Month') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        // 4 days
        return stockTrans.time > Date.now() - 2.628e9;
      });

      data = [
        {
          time:
            Date.now() - 2.628e9 < earliestTime
              ? earliestTime
              : Date.now() - 2.628e9,
          price: data[0].price,
        },
        ...data,
      ];
    } else if (timeDomain == 'Year') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 3.1536e10;
      });

      data = [
        {
          time:
            Date.now() - 3.1536e10 < earliestTime
              ? earliestTime
              : Date.now() - 3.1536e10,
          price: data[0].price,
        },
        ...data,
      ];
    }

    return data;
  }

  function generateDataForDomain(business, currentPrice) {
    let data = [
      ...business.stockHistory,
      {
        time: Date.now(),
        price: currentPrice,
        citizenID: 'SYSTEM',
        citizenName: 'SYSTEM',
        bought: false,
      },
    ];

    const foundTimes = new Set();

    // Filter duplicate times for better display
    data = data
      .reverse()
      .filter((stockTrans) => {
        if (!foundTimes.has(stockTrans.time)) {
          foundTimes.add(stockTrans.time);
          return true;
        } else return false;
      })
      .reverse();

    // 'Past Charlington 10 Years',
    //     'Past Charlington Year',
    //     'Past Charlington Month',
    //     'Past Charlington Day',
    if (timeDomain == 'Hour') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 3600000;
      });

      data = [
        {
          time:
            Date.now() - 3600000 < earliestTime
              ? earliestTime
              : Date.now() - 3600000,
          price: data[0].price,
          citizenID: 'SYSTEM',
          citizenName: 'SYSTEM',
          bought: false,
        },
        ...data,
      ];
    } else if (timeDomain == 'Day') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 86400000;
      });

      data = [
        {
          time:
            Date.now() - 86400000 < earliestTime
              ? earliestTime
              : Date.now() - 86400000,
          price: data[0].price,
          citizenID: 'SYSTEM',
          citizenName: 'SYSTEM',
          bought: false,
        },
        ...data,
      ];
    } else if (timeDomain == 'Week') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 604800000;
      });

      data = [
        {
          time:
            Date.now() - 604800000 < earliestTime
              ? earliestTime
              : Date.now() - 604800000,
          price: data[0].price,
          citizenID: 'SYSTEM',
          citizenName: 'SYSTEM',
          bought: false,
        },
        ...data,
      ];
    } else if (timeDomain == 'Month') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        // 4 days
        return stockTrans.time > Date.now() - 2.628e9;
      });

      data = [
        {
          time:
            Date.now() - 2.628e9 < earliestTime
              ? earliestTime
              : Date.now() - 2.628e9,
          price: data[0].price,
          citizenID: 'SYSTEM',
          citizenName: 'SYSTEM',
          bought: false,
        },
        ...data,
      ];
    } else if (timeDomain == 'Year') {
      let earliestTime = Date.now();
      //let earliestPrice = currentPrice;

      data = data.filter((stockTrans) => {
        if (stockTrans.time < earliestTime) {
          earliestTime = stockTrans.time;
          //earliestPrice = stockTrans.price;
        }

        return stockTrans.time > Date.now() - 3.1536e10;
      });

      data = [
        {
          time:
            Date.now() - 3.1536e10 < earliestTime
              ? earliestTime
              : Date.now() - 3.1536e10,
          price: data[0].price,
          citizenID: 'SYSTEM',
          citizenName: 'SYSTEM',
          bought: false,
        },
        ...data,
      ];
    }
    //   ?

    //   ...business.stockHistory.filter((stockTrans) => {
    //     return  stockTrans.time > Date.now() - 2600000;
    //   }),
    //   ,
    // ]

    //const last = ;

    return data;
  }

  let totalOriginallyInvested = 0;
  let totalSharesOwnedAcrossAllInvestments = 0;
  let currentTotalValueAcrossAllInvestments = 0;

  businesses.forEach((business) => {
    const currentValue =
      business.westers /
      business.stockHistory.filter((stockTrans) => {
        return stockTrans.bought == true;
      }).length;

    let currentPriceIfBought = currentValue + currentValue * 0.05;

    const numberOfSharesIfBought =
      business.stockHistory.filter((stockTrans) => {
        return stockTrans.bought == true;
      }).length + 1;

    let newBusinessBalanceIfBought =
      currentPriceIfBought * numberOfSharesIfBought;

    // Make up the difference
    currentPriceIfBought = newBusinessBalanceIfBought - business.westers;

    // const stockUp =
    //   generateDataForDomain(business, currentPriceIfBought)[0].price -
    //     business.stockHistory[business.stockHistory.length - 1].price <=
    //   0;

    const userBoughtTransactions = business.stockHistory.filter((trans) => {
      return trans.citizenID == user.citizenID && trans.bought == true;
    });

    totalSharesOwnedAcrossAllInvestments += userBoughtTransactions.length;

    let totalOriginalValue = 0;
    userBoughtTransactions.forEach((trans) => {
      totalOriginalValue += trans.amountPaid ? trans.amountPaid : 0;
    });

    totalOriginallyInvested += totalOriginalValue;

    //setTotalInvested(totalInvested + totalOriginalValue);

    let priceIfSold = currentValue;

    let currentTotalShareValue = 0;

    let newTotalSharesOwnedIfSold = business.stockHistory.filter((trans) => {
      return trans.bought == true;
    }).length;

    let newBusinessBalanceIfSold = business.westers;
    let oldBusinessBalanceIfSold = business.westers;

    for (let i = 0; i < userBoughtTransactions.length; i++) {
      priceIfSold = priceIfSold / 1.05;
      //if (priceIfSold <= 0) priceIfSold = 0;

      newTotalSharesOwnedIfSold--;

      newBusinessBalanceIfSold = priceIfSold * newTotalSharesOwnedIfSold;

      // Make up the difference
      currentTotalShareValue +=
        oldBusinessBalanceIfSold - newBusinessBalanceIfSold;
      oldBusinessBalanceIfSold = newBusinessBalanceIfSold;
    }

    currentTotalValueAcrossAllInvestments += currentTotalShareValue;
  });

  const totalReturnAcrossAllInvestments =
    currentTotalValueAcrossAllInvestments - totalOriginallyInvested;

  const summaryDataForDomain = generateSummaryDataForDomain();

  const summaryDataForDomainUp =
    summaryDataForDomain[summaryDataForDomain.length - 1].price -
      summaryDataForDomain[0].price >=
    0;

  console.log(
    'stock up',
    summaryDataForDomain[summaryDataForDomain.length - 1].price,
    summaryDataForDomain[0].price,
    summaryDataForDomainUp,
  );

  let lowestSummaryDataPrice = summaryDataForDomain.reduce((lowest, current) =>
    current.price < lowest.price ? current : lowest,
  );

  if (lowestSummaryDataPrice != null)
    lowestSummaryDataPrice = lowestSummaryDataPrice.price;
  else lowestSummaryDataPrice = 0;

  let highestSummaryDataPrice = summaryDataForDomain.reduce((max, current) =>
    current.price > max.price ? current : max,
  );

  if (highestSummaryDataPrice != null)
    highestSummaryDataPrice = highestSummaryDataPrice.price;
  else highestSummaryDataPrice = 0;

  console.log('low high', lowestSummaryDataPrice, highestSummaryDataPrice);

  return (
    <div className='mx-0 lg:mx-10 my-1 lg:my-5 bg-gray-900'>
      <div className='flow-root py-2 sticky top-0 bg-gray-900 z-50'>
        <div className='float-left'>
          <p className='text-4xl font-bold'>Stock Market</p>
        </div>
        <div className='float-right'>
          <p className='font-bold text-center text-xl'>Balance</p>
          <p className='text-center text-xl border border-gray-400 shadow font-semibold bg-gray-600 px-8'>
            W{westers.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </p>
        </div>
      </div>
      {businesses && initialStockPricesWhenLoaded.size > 0 ? (
        <>
          <div className=' bg-black p-8 border border-gray-700'>
            <div className='flex flex-wrap gap-x-10 gap-y-2 border-b pb-4 border-gray-500'>
              <div className=''>
                <strong className='text-gray-400 text-lg'>
                  Total Shares Owned
                </strong>
                <p className='text-gray-100 text-xl'>
                  {totalSharesOwnedAcrossAllInvestments
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </p>
              </div>
              <div className=''>
                <strong className='text-gray-400 text-lg'>
                  Total Originally Invested
                </strong>
                <p className='text-gray-100 text-xl'>
                  W
                  {totalOriginallyInvested
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </p>
              </div>
              <div className=''>
                <strong className='text-gray-400 text-lg'>
                  Current Total Value
                </strong>
                <p className='text-gray-100 text-xl'>
                  W
                  {currentTotalValueAcrossAllInvestments
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </p>
              </div>
              {true ? (
                <div className=''>
                  <strong className='text-gray-400 text-lg'>
                    Your Total Return
                  </strong>
                  <p
                    className={
                      'text-xl ' +
                      (totalReturnAcrossAllInvestments >= 0
                        ? 'text-green-500'
                        : 'text-red-600')
                    }
                  >
                    {totalReturnAcrossAllInvestments < 0 ? '-' : '+'}W
                    {Math.abs(totalReturnAcrossAllInvestments)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                    (
                    {totalReturnAcrossAllInvestments == 0 ||
                    totalOriginallyInvested == 0
                      ? '0.0'
                      : (totalReturnAcrossAllInvestments < 0 ? '-' : '+') +
                        Math.abs(
                          (totalReturnAcrossAllInvestments /
                            totalOriginallyInvested) *
                            100,
                        )
                          .toFixed(1)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    %)
                  </p>
                </div>
              ) : null}
            </div>
            <div className='w-full'>
              <div className='md:w-5/6 w-full flex justify-center border-b z-0 border-gray-500'>
                <LineChart
                  className='z-0'
                  width='100%'
                  height={300}
                  responsive
                  data={summaryDataForDomain}
                  margin={{ top: 5, right: 30, left: 5, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray='3 3' /> */}
                  <XAxis
                    hide
                    dataKey='time'
                    scale='time'
                    type='number'
                    domain={[
                      summaryDataForDomain[0],
                      summaryDataForDomain[summaryDataForDomain.length - 1],
                    ]}
                  />
                  {/* <Tooltip /> */}
                  <YAxis
                    hide
                    domain={[
                      lowestSummaryDataPrice / 1.1,
                      highestSummaryDataPrice * 1.2,
                    ]}
                  ></YAxis>

                  {/* <Legend /> */}
                  <Line
                    //isAnimationActive={false}
                    name='Aggregate Price'
                    strokeWidth={1.85}
                    unit=' Westers'
                    type='monotone'
                    dataKey='price'
                    animationDuration={900}
                    stroke={
                      summaryDataForDomainUp ? stockUpColor : stockDownColor
                    }
                    dot={(dotProps) => {
                      const { cx, cy, value, index } = dotProps;
                      const circleFillColor = summaryDataForDomainUp
                        ? stockUpColor
                        : stockDownColor;
                      if (index === summaryDataForDomain.length - 1) {
                        return (
                          // <div class='flex justify-center'>
                          //   <div class='h-16 w-16 animate-pulse rounded-full bg-blue-400'></div>
                          // </div>
                          <svg className='animate-pulse'>
                            <circle
                              cx={cx}
                              cy={cy}
                              r={4}
                              fill={circleFillColor}
                              // stroke='white'
                              // strokeWidth={}
                            />
                          </svg>
                        );
                      }
                    }}
                  />
                </LineChart>
              </div>
              <div>
                {timeDomainOptions.map((timeDomOpt) => {
                  return (
                    <button
                      className={
                        (timeDomOpt == timeDomain ? 'bg-gray-500' : '') +
                        ' text-white mx-1 my-2 p-2 rounded font-bold'
                      }
                      onClick={() => {
                        setTimeDomain(timeDomOpt);
                      }}
                    >
                      {timeDomOpt}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          <br />
          <br />
        </>
      ) : null}
      <input
        className='rounded w-full border-2 border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 p-2 mt-3 mb-6'
        placeholder='Search businesses...'
        value={businessFilterInput}
        onChange={(event) => {
          setBusinessFilterInput(event.target.value);
          localStorage.setItem('businessFilterInput', event.target.value);
          setFilteredBusinesses([
            ...businesses.filter((business) => {
              return business.name
                .toUpperCase()
                .includes(event.target.value.toUpperCase());
            }),
          ]);
        }}
      ></input>
      {businesses && initialStockPricesWhenLoaded.size > 0 ? (
        <div>
          {businesses
            .filter((bus) => {
              if (businessFilterInput != null)
                return bus.name
                  .toUpperCase()
                  .includes(businessFilterInput.toUpperCase());
              else return true;
            })
            // .sort((bus1, bus2) => {
            //   return bus1.stockHistory.find((stockTrans) => {
            //     return (
            //       stockTrans.citizenID == user.citizenID && stockTrans.bought
            //     );
            //   }) != null
            //     ? -1
            //     : bus2.stockHistory.find((stockTrans) => {
            //         return (
            //           stockTrans.citizenID == user.citizenID &&
            //           stockTrans.bought
            //         );
            //       }) != null
            //     ? 1
            //     : 0;
            // })
            .sort((bus1, bus2) => {
              return (
                initialStockPricesWhenLoaded.get(bus2.businessID) -
                initialStockPricesWhenLoaded.get(bus1.businessID)
              );
            })
            .map((business) => {
              const currentValue =
                business.westers /
                business.stockHistory.filter((stockTrans) => {
                  return stockTrans.bought == true;
                }).length;

              let currentPriceIfBought = currentValue + currentValue * 0.05;

              const numberOfSharesIfBought =
                business.stockHistory.filter((stockTrans) => {
                  return stockTrans.bought == true;
                }).length + 1;

              let newBusinessBalanceIfBought =
                currentPriceIfBought * numberOfSharesIfBought;

              // Make up the difference
              currentPriceIfBought =
                newBusinessBalanceIfBought - business.westers;

              const stockUp =
                generateDataForDomain(business, currentPriceIfBought)[0].price -
                  business.stockHistory[business.stockHistory.length - 1]
                    .price <=
                0;

              const userBoughtTransactions = business.stockHistory.filter(
                (trans) => {
                  return (
                    trans.citizenID == user.citizenID && trans.bought == true
                  );
                },
              );

              let totalOriginalValue = 0;
              userBoughtTransactions.forEach((trans) => {
                totalOriginalValue += trans.amountPaid ? trans.amountPaid : 0;
              });

              //setTotalInvested(totalInvested + totalOriginalValue);

              let priceIfSold = currentValue;

              let currentTotalShareValue = 0;

              let newTotalSharesOwnedIfSold = business.stockHistory.filter(
                (trans) => {
                  return trans.bought == true;
                },
              ).length;

              let newBusinessBalanceIfSold = business.westers;
              let oldBusinessBalanceIfSold = business.westers;

              for (let i = 0; i < userBoughtTransactions.length; i++) {
                priceIfSold = priceIfSold / 1.05;
                //if (priceIfSold <= 0) priceIfSold = 0;

                newTotalSharesOwnedIfSold--;

                newBusinessBalanceIfSold =
                  priceIfSold * newTotalSharesOwnedIfSold;

                // Make up the difference
                currentTotalShareValue +=
                  oldBusinessBalanceIfSold - newBusinessBalanceIfSold;
                oldBusinessBalanceIfSold = newBusinessBalanceIfSold;
              }

              const totalReturn = currentTotalShareValue - totalOriginalValue;

              const dataForDomain = generateDataForDomain(
                business,
                currentPriceIfBought,
              );

              return (
                <div className=' p-8 mb-2 border border-gray-300 bg-black'>
                  <div className='flex flex-wrap md:flex-nowrap justify-between pb-2'>
                    <div>
                      <div className='md:flex gap-2 pr-2'>
                        <p className='text-2xl font-bold'>{business.name}</p>
                        <button
                          onClick={() => {
                            localStorage.setItem(
                              'selectedBusiness',
                              JSON.stringify(business),
                            );
                            window.location.href = '/business';
                          }}
                          className='rounded-full px-3 py-2 mb-1 font-semibold bg-sky-400 hover:bg-sky-500 text-black'
                        >
                          Go to Business
                        </button>
                      </div>

                      <p className='text-lg'>{business.description}</p>

                      <p className='text-lg'>{business.businessID}</p>
                      <p className='text-lg'>
                        <strong>
                          W
                          {business.westers
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </strong>{' '}
                        in Bank
                      </p>
                    </div>
                    <div className='justify-end text-right w-full md:w-auto'>
                      <p
                        className={
                          'text-4xl font-bold ' +
                          (stockUp ? 'text-green-500' : 'text-red-600')
                        }
                      >
                        W
                        {currentPriceIfBought
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </p>
                    </div>
                  </div>
                  <div className='md:w-3/4 w-full border-b z-0 border-gray-500'>
                    <LineChart
                      className='z-0'
                      responsive
                      width='100%'
                      height={250}
                      data={dataForDomain}
                      margin={{ top: 5, right: 30, left: 5, bottom: 0 }}
                    >
                      {/* <CartesianGrid strokeDasharray='3 3' /> */}
                      <XAxis
                        hide
                        dataKey='time'
                        scale='time'
                        type='number'
                        domain={[
                          dataForDomain[0],
                          dataForDomain[dataForDomain.length - 1],
                        ]}
                      />
                      {/* <Tooltip /> */}
                      {/* <Legend /> */}
                      <Line
                        animationDuration={900}
                        name='Price'
                        strokeWidth={1.85}
                        unit=' Westers'
                        type='monotone'
                        dataKey='price'
                        stroke={stockUp ? stockUpColor : stockDownColor}
                        dot={(dotProps) => {
                          const { cx, cy, value, index } = dotProps;
                          const circleFillColor = stockUp
                            ? stockUpColor
                            : stockDownColor;
                          if (index === dataForDomain.length - 1) {
                            return (
                              // <div class='flex justify-center'>
                              //   <div class='h-16 w-16 animate-pulse rounded-full bg-blue-400'></div>
                              // </div>
                              <svg className='animate-pulse'>
                                <circle
                                  cx={cx}
                                  cy={cy}
                                  r={4}
                                  fill={circleFillColor}
                                  // stroke='white'
                                  // strokeWidth={}
                                />
                              </svg>
                            );
                          }
                        }}
                      />
                    </LineChart>
                  </div>
                  <div>
                    {timeDomainOptions.map((timeDomOpt) => {
                      return (
                        <button
                          className={
                            (timeDomOpt == timeDomain ? 'bg-gray-500' : '') +
                            ' text-white mx-1 my-2 p-2 rounded font-bold'
                          }
                          onClick={() => {
                            setTimeDomain(timeDomOpt);
                          }}
                        >
                          {timeDomOpt}
                        </button>
                      );
                    })}
                  </div>
                  <br />

                  {/* Current Standing */}
                  <div>
                    <p className='font-semibold text-2xl'>Current Standing</p>
                    <div className='flex flex-wrap gap-x-12 gap-y-2'>
                      <div className=''>
                        <strong className='text-gray-400 text-lg'>
                          Shares Owned
                        </strong>
                        <p className='text-gray-100 text-xl'>
                          {userBoughtTransactions.length
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </p>
                      </div>

                      <div className=''>
                        <strong className='text-gray-400 text-lg'>
                          Original Total Share Value
                        </strong>
                        <p className='text-gray-100 text-xl'>
                          W
                          {totalOriginalValue
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </p>
                      </div>
                      <div className=''>
                        <strong className='text-gray-400 text-lg'>
                          Current Total Share Value
                        </strong>
                        <p className='text-gray-100 text-xl'>
                          W
                          {currentTotalShareValue
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </p>
                      </div>
                      {true ? (
                        <div className=''>
                          <strong className='text-gray-400 text-lg'>
                            Your Return
                          </strong>
                          <p
                            className={
                              'text-xl ' +
                              (totalReturn >= 0
                                ? 'text-green-500'
                                : 'text-red-600')
                            }
                          >
                            {totalReturn < 0 ? '-' : '+'}W
                            {Math.abs(totalReturn)
                              .toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                            (
                            {totalReturn == 0 || totalOriginalValue == 0
                              ? '0.0'
                              : (totalReturn < 0 ? '-' : '+') +
                                Math.abs(
                                  (totalReturn / totalOriginalValue) * 100,
                                )
                                  .toFixed(1)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            %)
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <br />
                  <br />

                  {/* Buy and sell */}
                  <div className='md:flex md:gap-2'>
                    <div>
                      <strong class='text-white'>Shares</strong>
                      <br />
                      <input
                        id='sharesInput'
                        onInput={(e) => {
                          //setBusinesses(updatedBusinesses);
                          updateSharesValid(e, business);
                        }}
                        value={business.sharesEntered}
                        className='mb-2 md:mb-0 md:w-24 w-full rounded appearance-textfield focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-2'
                        type='Number'
                        min={0}
                        //max={50}
                      ></input>
                    </div>
                    <div className='flex gap-2 md:justify-between align-baseline flex-wrap md:flex-row items-end'>
                      <button
                        onClick={() =>
                          onClickBuySell(true, business, currentValue, false)
                        }
                        className={
                          (business.userEnteringValidSharesForBuy
                            ? 'bg-sky-400 hover:bg-sky-500 text-black'
                            : 'bg-sky-300 text-gray-300') +
                          ' w-full md:w-auto text-lg rounded-full shadow-sm px-10 py-2 font-semibold'
                        }
                      >
                        Buy{business.userBuyHint}
                      </button>
                      {/* <button
                    onClick={() =>
                      onClickBuySell(true, business, currentPrice, true)
                    }
                    className={
                      (business.userEnteringValidSharesForBuy
                        ? 'bg-sky-400 hover:bg-sky-500 text-black'
                        : 'bg-sky-300 text-gray-300') +
                      ' text-lg  rounded-md shadow-sm py-2 px-14 font-semibold'
                    }
                  >
                    Buy (Other Person)
                  </button> */}
                      <button
                        className={
                          (business.userEnteringValidSharesForSell
                            ? 'bg-sky-400 hover:bg-sky-500 text-black'
                            : 'bg-sky-300 text-gray-300') +
                          ' w-full md:w-auto text-lg rounded-full shadow-sm px-10 py-2 font-semibold'
                        }
                        onClick={() =>
                          onClickBuySell(false, business, currentValue, false)
                        }
                      >
                        Sell{business.userSellHint}
                      </button>
                      {/* <button
                    className={
                      (business.userEnteringValidSharesForSell
                        ? 'bg-sky-400 hover:bg-sky-500 text-black'
                        : 'bg-sky-300 text-gray-300') +
                      ' text-lg rounded-md shadow-sm py-2 px-14 font-semibold'
                    }
                    onClick={() =>
                      onClickBuySell(false, business, currentPrice, true)
                    }
                  >
                    Sell (Other Person)
                  </button> */}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(StockMarket);
